export { default } from './ProgramAccordion';
